/* Shipping options sheet — extracted from the header custom_liquid block 2026-08-25.

   That setting silently REJECTS an update once it passes roughly 50,000 characters: the push
   reports success, the theme keeps the previous value, and the change never appears. Two edits
   vanished that way before it was spotted by diffing markers in the served page against the local
   file. Code belongs in an asset; the block keeps only what needs Liquid.

   Config comes from window.NTF_SHIP, rendered inline by the block. */
/* ntf-ship-sheet - real methods, real prices, real dates, for this cart and this country.

   The popup stated one hard-coded line ("Estimated with Express shipping"). This asks Shopify what
   it would actually charge: /cart/shipping_rates.json returns only the rates whose band matches the
   current cart, so Standard drops out above its band and Priority comes back at 0.00 once the
   country threshold is met. No logic here to drift out of step with checkout.

   delivery_days is in WORKDAYS, so arrival dates skip weekends - counting calendar days would
   over-promise on every Friday order.

   The country is a control, not a label: detection follows the market and is wrong behind a VPN, and
   a shipping quote for the wrong country is worse than none. The choice is remembered per browser.

   Lives here rather than in the drawer markup because the drawer is injected by the Section
   Rendering API, where inline scripts never execute. */
(function(){
  var CFG = window.NTF_SHIP || {iso:'', countries:[], freeFrom:0};
  if (!CFG.countries.length) return;
  var DETECTED = CFG.iso;
  /* Dependencies, overseas collectivities and small island territories. They stay in the ZONE
     data — a visitor detected in Åland is still priced, quoted and charged correctly — but they
     come out of the PICKER, which is a list a human scrolls. 236 entries with Ascension Island,
     Svalbard and the U.S. Outlying Islands in it is a worse list than ~195 without them, and
     nobody is hunting for those names in a cart.

     ISO codes, not names: names differ by locale and would silently stop matching. */
  var TERRITORIES = ("AX,AI,AC,AW,BM,BQ,BV,IO,VG,KY,CX,CC,CK,CW,FK,FO,GF,PF,TF,GI,GL,GP,GG,HM,"
    + "IM,JE,MQ,YT,MS,NC,NU,NF,PN,RE,BL,SH,MF,PM,SX,GS,SJ,TA,TK,TC,UM,WF,EH,VA,AQ").split(",");
  var ALL_COUNTRIES = CFG.countries || [];
  /* Only countries a Shopify shipping zone covers (Kai, 25 Sept: "some countries available to
     select that we don't actually ship to ... match the zones of our shopify shipping settings").
     The list above is the MARKETS list; the zone table's map is the shipping list, complete when it
     says a:1 (see snippets/ntf-shipping-zones-all.liquid). An older table without the flag filters
     nothing rather than everything. */
  (function(){
    var zs = CFG.zones;
    if (!zs || !zs.a || !zs.m) return;
    ALL_COUNTRIES = ALL_COUNTRIES.filter(function(c){ return zs.m[c.iso] != null; });
  })();
  var COUNTRIES = ALL_COUNTRIES.filter(function(c){
    return TERRITORIES.indexOf(c.iso) < 0;
  });
  /* Never hide the visitor's OWN country: someone browsing from Guernsey must still see Guernsey
     selected rather than a list that silently reset them to somewhere else. */
  (function(){
    var iso = CFG.iso;
    if (!iso || TERRITORIES.indexOf(iso) < 0) return;
    var own = null;
    ALL_COUNTRIES.forEach(function(c){ if (c.iso === iso) own = c; });
    if (own) COUNTRIES = COUNTRIES.concat([own]).sort(function(a, b){
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
  })();
  var FREE_PARTS = String(CFG.free || "").split("|");
  var FREE_FROM = parseFloat(FREE_PARTS[0]) || 0;
  // "Priority shipping" -> "Priority", so the sentence reads "free Priority shipping".
  var FREE_SVC = (FREE_PARTS[1] || "").replace(/ *shipping */i, "").trim();
  // Third field: the threshold at which the FASTEST service becomes free. Priority going free at
  // 75 while Express still costs money until 250 is exactly the gap the cart was hiding.
  var FREE_EXPRESS = parseFloat(FREE_PARTS[2]) || 0;
  /* The visitor's whole zone: every method with its name, price and threshold. Needed for the
     price a service costs BEFORE a threshold makes it free — /cart/shipping_rates.json reports
     what this cart pays and nothing about what it would have paid. */
  var ZONE = CFG.zone || null;
  /* Every zone's free-shipping thresholds, so the sheet can answer for the country the customer
     PICKED and not only for the one they are browsing in. {z:[{c,f}], m:{ISO:index}, d:Rest of
     World} — see snippets/ntf-shipping-zones-all.liquid. */
  var ZONES = CFG.zones || null;
  function zoneOf(iso){
    if (!ZONES || !ZONES.z) return null;
    var i = ZONES.m && ZONES.m[iso];
    /* With a complete map (a:1) an unlisted country is in no zone and has no rates. The older
       table left Rest of World out of the map, so there "unlisted" meant Rest of World. */
    if (i == null && !ZONES.a) i = ZONES.d;
    return i == null ? null : ZONES.z[i] || null;
  }

  /* The undiscounted price of a service, or 0 when the zone lists no paid variant of it. A zone
     carries the same service twice — "Express shipping" at 4.95 from 0, and again at 0 from 250 —
     so the paid one is the highest price under that name. */
  function basePrice(name, total){
    if (!ZONE || !ZONE.methods) return 0;
    var short = shortName(name).toLowerCase(), best = null;
    ZONE.methods.forEach(function(m){
      if (m.p <= 0) return;                          // the free variant is what we are pricing AGAINST
      if (shortName(m.n).toLowerCase() !== short) return;
      if (m.from > total) return;                    // a bracket this cart never reached
      // NL lists Express three times: 6.95 from 10, 4.95 from 75, free from 250. The saving is
      // measured against the bracket this cart WOULD have paid — the highest threshold it clears,
      // not the dearest price in the zone.
      if (best === null || m.from > best.from) best = m;
    });
    return best ? best.p : 0;
  }

  /* sessionStorage, not localStorage (review, 25 Sept). Since 24 Sept the pick drives the cart
     row's date and the ladder's free-shipping rung, not only the sheet - so a country picked once
     to compare must not follow the customer for weeks. A new tab starts from the detected market. */
  var chosen = null;
  try { chosen = sessionStorage.getItem("ntfShipCountry"); } catch(e){}
  var ISO = chosen || DETECTED;

  /* Colour skin, chosen on a device with ?ntf-ship-skin=1..4 and remembered per browser. The
     attribute goes on <html>, not on the sheet, because the sheet is re-rendered on every country
     change and would lose it. Same shape as the drawer layout switch. */
  (function(){
    var m = /[?&]ntf-ship-skin=([a-z0-9]+)/i.exec(location.search);
    if (m) {
      var v = m[1].toLowerCase();
      try {
        if (v === "off") localStorage.removeItem("ntfShipSkin");
        else localStorage.setItem("ntfShipSkin", v);
      } catch (e) {}
    }
    var skin = "";
    try { skin = localStorage.getItem("ntfShipSkin") || ""; } catch (e) {}
    /* Green is the chosen default. The URL flag still overrides it, and ?ntf-ship-skin=off
       returns to the default rather than to the old sand palette. */
    document.documentElement.setAttribute("data-ntf-skin", skin || "3");
  })();

  /* The endpoint needs a postcode for some destinations and a province for US/CA, where it answers
     {"province":[...]} instead of rates. Only the markets that need one are listed; everywhere else
     is fine without. */
  /* VERIFIED against the live rate endpoint by tools/zip-probe.js — every value below returned
     real rates for a real cart; anything the shop rejected was discarded rather than shipped.

     Why these exist at all: /cart/shipping_rates.json validates the address BEFORE it looks at any
     zone, so a country with no postal code comes back {"zip":["Enter a postal code"]} and one that
     needs a region comes back {"province":["Select a state"]} — never rates. With 21 countries in
     the table, every other destination fell through to "options are shown at checkout", which read
     like missing zones and was not. Coverage is now 216/236.

     None of this reaches the customer or the checkout: it is a stand-in address used to ask the
     rate question, and the real address is collected at checkout as before. */
  var ZIP = {AD:"AD500",AE:"00000",AF:"1001",AL:"1001",AM:"0010",AR:"C1002",AT:"1010",AU:"2000",AZ:"1000",
    BA:"71000",BB:"BB11000",BD:"1000",BE:"1000",BG:"1000",BH:"1000",BN:"BS8811",BO:"0001",BR:"01310-100",
    BT:"12345",BY:"220030",CA:"M5H 2N2",CD:"00243",CF:"1000",CH:"8001",CL:"8320000",CO:"110111",CR:"10101",
    CY:"1010",CZ:"11000",DE:"10115",DK:"1050",DO:"10101",DZ:"16000",EC:"170150",EE:"10111",EG:"11511",
    EH:"1000",ER:"1000",ES:"28001",ET:"1000",FI:"00100",FO:"100",FR:"75001",GA:"00241",GB:"SW1A 1AA",
    GE:"0105",GL:"3900",GQ:"1000",GR:"10431",GT:"01001",GW:"1000",HN:"11101",HR:"10000",HU:"1011",
    ID:"10110",IE:"D01 F5P2",IL:"9103501",IN:"110001",IO:"1000",IQ:"10001",IS:"101",IT:"00100",JO:"11118",
    JP:"100-0001",KE:"00100",KG:"720001",KH:"12000",KI:"1000",KM:"1000",KR:"04524",KY:"1000",KZ:"010000",
    LA:"01000",LB:"1107",LI:"9490",LK:"00100",LR:"1000",LS:"100",LT:"01100",LU:"1009",LV:"1050",LY:"00218",
    MA:"10000",MC:"98000",MD:"2001",ME:"81000",MG:"101",MK:"1000",ML:"1000",MM:"11181",MN:"14200",MR:"1000",
    MT:"VLT1117",MV:"20026",MX:"06000",MY:"50000",MZ:"1100",NA:"10001",NC:"98800",NE:"1000",NG:"100001",
    NI:"11001",NL:"1012AB",NO:"0150",NP:"44600",NZ:"6011",OM:"100",PA:"0801",PE:"15001",PF:"98700",PG:"111",
    PH:"1000",PK:"44000",PL:"00-001",PS:"1000",PT:"1000-001",PY:"1101",RO:"010011",RS:"11000",RU:"101000",
    RW:"00250",SA:"11564",SB:"1000",SD:"11111",SE:"11120",SG:"018956",SI:"1000",SK:"81101",SM:"47890",
    SN:"11000",SO:"1000",SS:"10000",ST:"1000",SV:"1101",SZ:"H100",TD:"1000",TH:"10200",TJ:"734001",
    TK:"1000",TM:"744000",TN:"1000",TR:"06010",TT:"120110",TV:"1000",TW:"100",UA:"01001",US:"10001",
    UY:"11000",UZ:"100000",VE:"1010",VN:"100000",XK:"10000",YE:"1000",ZA:"0002",ZM:"10101"};
  /* Shopify refuses to quote without a province for these countries — it answers with a
     {"province":[...]} prompt instead of rates, which sent the sheet down its error path. The
     value does not change the price (verified across four US states and two Canadian provinces),
     so a fixed representative is enough. */
  var PROV = {AE:"Dubai",AR:"Buenos Aires",AU:"New South Wales",BR:"São Paulo",CA:"Ontario",
    CL:"Región Metropolitana de Santiago",CO:"Bogotá, D.C.",CR:"San José",EG:"Cairo",ES:"Madrid",
    GT:"Guatemala",HK:"Hong Kong Island",ID:"Jakarta",IE:"Dublin",IN:"Delhi",IT:"Roma",JP:"Tokyo",
    KR:"Seoul",KW:"Al Asimah",MX:"Ciudad de México",MY:"Kuala Lumpur",NG:"Lagos",PA:"Panamá",PE:"Callao",
    PH:"Metro Manila",PT:"Lisboa",RO:"București",RU:"Moscow",SV:"San Salvador",TH:"Bangkok",US:"New York",
    UY:"Montevideo",VE:"Distrito Capital",ZA:"Gauteng"};
  var cache = {};

  /* Rows from the compiled zone table, for a cart Shopify will not quote — an EMPTY one, which is
     every product page before anything is added. Same services, same transit days, same free-from
     thresholds; no price, because there is no cart to price. Slowest first, as Shopify's own
     price-sorted list comes back (Priority, then Express). */
  function compiledRates(iso){
    var z = zoneOf(iso);
    if (!z || !z.t) return [];
    var out = [];
    Object.keys(z.t).forEach(function(k){
      var d = z.t[k]; if (!d || !d.length) return;
      /* Named the way Shopify names its rates ("Priority shipping"): a lookup name, never shown as
         it is - svcLabel() prints it as "Priority". */
      out.push({ name: k.charAt(0).toUpperCase() + k.slice(1) + " shipping", price: "", delivery_days: d, compiled: true });
    });
    out.sort(function(a, b){ var A = a.delivery_days, B = b.delivery_days; return B[B.length-1] - A[A.length-1]; });
    return out;
  }
  var SYMBOL = { EUR:"€", GBP:"£", USD:"$" };
  /* cur names the currency the AMOUNT is in — a GB threshold is written in pounds because that is
     what the delivery profile says, whatever currency the shop is being browsed in. */
  function fmtMoney(v, cur){
    if (v === 0) return shipT('free', 'Free');
    // whole amounts read better bare: a threshold is "75", a rate is "4,95"
    return (SYMBOL[cur] || "€") + (v % 1 === 0 ? String(v) : v.toFixed(2).replace(".", ","));
  }
  /* A RATE, unlike a threshold, always arrives in the currency the customer is being charged in —
     /cart/shipping_rates.json quotes in the presentment currency. Calling fmtMoney with no currency
     fell through to the euro sign, so a Swedish cart read "€146,69" for a 146,69 kr rate and a
     Japanese one "€4596". Intl gives the right symbol and placement for any market, including the
     ones SYMBOL above has never heard of. Same formatter the cart drawer uses, so the two agree. */
  function fmtLocal(v){
    if (v === 0) return shipT('free', 'Free');
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
    // A round rate loses its ",00" too (Kai, 24 Sept) — the same rule the rest of the theme now
    // follows. fmtMoney below has always done this; this is only bringing Intl into line with it.
    var d = v % 1 === 0 ? 0 : 2;
    try { return new Intl.NumberFormat('nl-NL', { style:'currency', currency:cur,
            minimumFractionDigits:d, maximumFractionDigits:d }).format(v); }
    catch(e){ return fmtMoney(v, cur); }
  }
  /* A THRESHOLD in the customer's money. Same formatter as fmtLocal, but a round number keeps its
     bare shape: "€ 250", not "€ 250,00". fmtMoney has always printed thresholds that way — "a
     threshold is 75, a rate is 4,95" — and converting one is no reason to start writing cents on
     it. Converted thresholds are tidied to a round figure anyway, so this is the normal case. */
  function fmtLocalThr(v){
    if (v === 0) return shipT('free', 'Free');
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
    var d = v % 1 === 0 ? 0 : 2;
    try { return new Intl.NumberFormat('nl-NL', { style:'currency', currency:cur,
            minimumFractionDigits:d, maximumFractionDigits:d }).format(v); }
    catch(e){ return fmtMoney(v, cur); }
  }
  /* Dispatch, then transit — they are different things.

     delivery_days from Shopify counts TRANSIT days, which start once the parcel leaves. Whether it
     leaves today depends on the cut-off, and the cut-off is per service:
       Express   13:00
       Priority  09:00
     Anything else falls back to the earlier cut-off, so an unknown service under-promises rather
     than over-promises.

     Times are the STORE's, not the customer's: a customer in New York ordering at 08:00 their time
     is well past a 13:00 Amsterdam cut-off, and using their clock would promise same-day dispatch
     that never happens. */
  var CUTOFF = { express: 13, priority: 9 };
  function cutoffFor(name){
    var n = String(name || "").toLowerCase();
    if (n.indexOf("express") >= 0) return CUTOFF.express;
    if (n.indexOf("priority") >= 0) return CUTOFF.priority;
    return CUTOFF.priority;
  }
  function storeNow(){
    try {
      return new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Amsterdam" }));
    } catch(e) { return new Date(); }
  }
  function isWorkday(d){ var w = d.getDay(); return w !== 0 && w !== 6; }
  function nextWorkday(d){
    var x = new Date(d.getTime());
    do { x.setDate(x.getDate() + 1); } while (!isWorkday(x));
    return x;
  }
  /* The day the parcel actually leaves. */
  function dispatchDay(cutHour){
    var now = storeNow();
    if (isWorkday(now) && now.getHours() < cutHour) return now;
    return nextWorkday(now);
  }
  /* n TRANSIT workdays after dispatch. */
  function addWorkdays(from, n){
    var d = new Date(from.getTime()), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isWorkday(d)) added++; }
    return d;
  }
  /* Weekday on a single date, dropped on a range. "Mon 31 Aug" removes the silent "…which day is
     that?" step, which matters most here, where someone is working out whether it lands before a
     birthday. On a range two weekdays is more string than signal. */
  function fmtDate(d, withDay){
    var o = withDay ? {weekday:"short",month:"short",day:"numeric"}
                    : {month:"short",day:"numeric"};
    try { return d.toLocaleDateString(document.documentElement.lang || undefined, o).replace(/,/g, ""); }
    catch(e){ return (d.getMonth()+1) + "/" + d.getDate(); }
  }
  /* "" when the zone has no transit times: the ABSENCE of a date. Until 25 Sept this returned the
     English words "At checkout", and three callers compared against them - a test that can never
     match once the words are translated (rule 1). Each caller now words the no-date case itself,
     through the bridge. */
  function whenText(days, name){
    if (!days || !days.length) return "";
    var from = dispatchDay(cutoffFor(name));
    /* Compare the DATES, not their strings: with the weekday added to the first and not the
       second, "Mon 31 Aug" never equalled "31 Aug" and a single day rendered as a range against
       itself. */
    var d1 = addWorkdays(from, days[0]), d2 = addWorkdays(from, days[days.length - 1]);
    var one = d1.getTime() === d2.getTime();
    if (one) return fmtDate(d1, true);
    var a = fmtDate(d1, false), b = fmtDate(d2, false);
    return a === b ? a : a + " \u2013 " + b;
  }
  /* Duties are only a question outside the customs union. Inside the EU there are none to speak of,
     so the line would be noise; outside it, it removes the single biggest hesitation on an
     international order. */
  var EU = "AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE".split(",");
  function outsideEU(){ return EU.indexOf(ISO) < 0; }
  /* The rate cards and the error state both carry it. */
  function dutyLine(){
    return outsideEU()
      ? '<p class="ntf-ship-duty">' + esc(shipT('ship-duties-covered', 'All duties and customs are covered by us.')) + '</p>'
      : '';
  }

  /* Time left to make today's dispatch, per service — each can have its own cut-off. A deadline
     the customer has to convert from a clock time ("order by 13:00") is worse than one already
     converted for them ("order within 2h 10m"), which is also the version that creates urgency
     honestly: it is simply what the clock says. */
  /* A deadline, not a countdown, and it moves through the day.

     Before the hand-over — 09:00 for Priority, 13:00 for Express — that is the deadline, and the
     parcel goes out today. Once it has passed, today's dispatch is gone and ordering any time
     before midnight makes the next one, so the deadline becomes the end of the ordering day. That
     matches the DATE printed beside it, which dispatchDay() has already moved.

     The original had both halves but the test backwards — `mins < ORDER_CLOSE` is true all day, so
     it printed 23:59 from midnight to midnight and the service times were never reached. */
  var ORDER_CLOSE = 23 * 60 + 59;
  function hhmm(mins){
    var h = Math.floor(mins / 60), m = mins % 60;
    return (h < 10 ? "0" : "") + h + ":" + (m < 10 ? "0" : "") + m;
  }
  /* The deadline as a bare clock time, "13:00". Separate from the sentence because the product
     page puts the time into a sentence of its own - it used to get it by cutting "Order before "
     off the English one, which stops matching the moment that sentence is translated. */
  function cutTime(name){
    var cut = cutoffFor(name);
    /* Off a working day there is no hand-over left to catch, so the end of the day is the honest
       deadline — the date beside it is already the next working one. */
    var now = storeNow();
    if (isWorkday(now) && now.getHours() < cut) return hhmm(cut * 60);
    return hhmm(ORDER_CLOSE);
  }
  function orderWithin(name){
    return shipT('ship-order-before', 'Order before %time%', { time: cutTime(name) });
  }
  /* A LOOKUP KEY - "priority", "express" - matched against the zone table and against the rate
     names Shopify returns, which stay English in every locale (measured 25 Sept on /nl, /de, /fr).
     Compared lowercased and never printed; svcLabel() below is the printed form. */
  function shortName(n){ return String(n||"").replace(/\s*shipping\s*/i,"").trim() || "shipping"; }
  /* The same service as a customer reads it: "Priority", "Express", "Standard" - names, which stay
     untranslated in every language (glossary). Only a rate with no name of its own needs a word,
     and that word goes through the bridge. */
  function svcLabel(n){
    var s = String(n||"").replace(/\s*shipping\s*/i,"").trim();
    return s || shipT('shipping', 'Shipping');
  }
  /* A rate with no transit time set in the delivery profile comes back with delivery_days [] (Morocco's
     paid Express, 18 Sept), so its card read "Confirmed at checkout". Filled from the compiled zone
     table for the same service and destination; a rate Shopify does date is left alone. */
  function fillDays(rates){
    var zt = (zoneOf(ISO) || {}).t || {};
    rates.forEach(function(r){
      if (r.delivery_days && r.delivery_days.length) return;
      var d = zt[shortName(r.name).toLowerCase()];
      if (d && d.length) r.delivery_days = d;
    });
    return rates;
  }

  /* Touch devices get a NATIVE select; only pointer devices get the custom combobox.

     The custom list is fine with a mouse and wrong on a phone: focusing the input raises the
     keyboard, the list renders underneath it, and there is no way to scroll to a country you cannot
     see. Typing did not help either, because the field sits above the fold once the keyboard is up.

     A native select has none of those problems — iOS shows its own wheel, which scrolls, needs no
     keyboard, and is the control people already know. Search is lost, but 236 options in a system
     picker with alphabetical order beats a search box you cannot reach. */
  /* The theme's own country select, on every device.

     This replaced a custom combobox that was wrong in three separate ways: the list rendered in
     flow, so opening it grew the whole sheet; it committed on touchstart, so a scroll gesture
     selected whatever row was under the thumb (this is how the quoted country became Albania);
     and it was capped at 40 rows, so scrolling could not reach most countries anyway.

     A native select has none of those failure modes, and it is the control the theme already uses
     for country on the cart page — same classes, so it inherits whatever the theme does with
     selects. iOS renders its own wheel: no keyboard, no layout shift, alphabetical, familiar. */
  var SELECT_CLASS = "ntf-ship-country w-full pl-5 pr-10 pt-3 pb-3 appearance-none border "
                   + "bg-transparent focus:border-current border-solid";
  /* Every word this sheet shows comes through the i18n bridge (snippets/ntf-i18n.liquid, keys under
     ntf_js in locales/*.json), read at the moment it is shown. Weglot is off on every theme since
     25 Sept, so an English literal here would be English on /nl, /de and /fr (rules 1 and 1b).

     A sentence with a value in it is ONE string with a named slot - 'Order before %time%', never
     'Order before ' + time - because the value does not sit in the same place in every language.
     The fallback is today's English: what a missing key or an unrendered bridge degrades to, with
     its slots filled the same way. */
  function shipT(key, fallback, vars){
    var en = !vars ? fallback : String(fallback).replace(/%([^%\s<>]{1,24})%/g, function(m, n){
      return (n in vars) ? String(vars[n]) : m;
    });
    return (typeof window.NTF_T === 'function') ? window.NTF_T(key, vars || null, en) : en;
  }
  /* Copy is data now - locale values can be edited in Shopify admin - so it is escaped on its way
     into innerHTML like any other data. */
  function esc(s){
    return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
      return { "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;" }[c];
    });
  }
  /* Every country as <option>s, for the select that carries the choice. */
  function countryOpts(){
    var opts = "";
    for (var i = 0; i < COUNTRIES.length; i++) {
      opts += '<option value="' + COUNTRIES[i].iso + '"'
           + (COUNTRIES[i].iso === ISO ? " selected" : "") + ">" + COUNTRIES[i].name + "</option>";
    }
    return opts;
  }
  /* PageSpeed, 17 Oct 2026: the sheet is mounted in the cart drawer on EVERY page, so the ~190
     <option>s were in the DOM of every page for a list few people open. The select now starts with
     the current country alone (what it shows, and what it submits) and is filled with the rest at
     the first touch, click, focus or key on the field (wire), before any picker can open, and in
     commitMenu before a value is written to it. Our own list (openMenu) never read the options; it
     builds from COUNTRIES. */
  function fillOptions(sel){
    if (!sel || !sel.hasAttribute("data-ntf-lazy")) return;
    sel.removeAttribute("data-ntf-lazy");
    sel.innerHTML = countryOpts();
  }
  function header(){
    var opts = "", cur = "";
    for (var i = 0; i < COUNTRIES.length; i++) {
      if (COUNTRIES[i].iso !== ISO) continue;
      cur = COUNTRIES[i].name;
      opts = '<option value="' + COUNTRIES[i].iso + '" selected>' + COUNTRIES[i].name + "</option>";
    }
    /* The mockup's field: "Shipping to" small and grey over the country in bold, a chevron right.
       No pin (Kai, 24 Sept) - the words say it.

       Not a <label> any more, and that is load-bearing. A label forwards a click to its control
       whatever the CSS says, so on a desktop the native popup opened however hard the select was
       suppressed - and the native popup is the bug (see openMenu). A div carries no such
       behaviour. Nothing is lost: on TOUCH the select still lies over the whole box at inset:0
       and takes the tap directly, which is what made the box clickable in the first place. */
    return '<div class="ntf-ship-where" role="button" aria-haspopup="listbox" aria-expanded="false">'
         + '<span class="ntf-ship-where-txt">'
         +   '<span class="ntf-ship-where-lbl">' + esc(shipT('shipping-to', 'Shipping to')) + '</span>'
         +   '<b class="ntf-ship-where-c">' + cur + '</b>'
         + '</span>'
         + '<span class="ntf-ship-where-chev" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>'
         + '<select id="ntf-ship-c" class="' + SELECT_CLASS + '" data-ntf-lazy aria-label="' + esc(shipT('shipping-to', 'Shipping to')) + '">'
         + opts + '</select></div>';
  }

  /* A re-render replaces the field the list hangs off; the list and its document listeners must
     go with it, or arrow keys and Enter keep acting on a list that is no longer on the page
     (review, 25 Sept). */
  function dropMenuIn(box){ if (MENU && box && box.contains(MENU.where)) closeMenu(true); }

  function renderCustom(box){
    dropMenuIn(box);
    /* No rates, no country picker: the wait is production time, not transit, so it does not vary by
       destination in any way we can state honestly. */
    box.innerHTML = '<p class="ntf-ship-lead"><b>' + esc(shipT('ship-custom-lead', 'Estimated delivery 8–10 weeks')) + '</b>'
      + '<span> ' + esc(shipT('ship-made-to-order', 'made to order')) + '</span></p>'
      + '<p class="ntf-ship-note">'
      + esc(shipT('ship-custom-note', 'Your order contains a custom size, which is made for you. Shipping options are shown at checkout.'))
      + '</p>';
  }

  function render(box, rates, total){
    dropMenuIn(box);
    /* Design B: a headline for the fastest option, the options as rows under column headers, and one
       bar carrying the cart value. Rows rather than columns because Shopify returns a different
       NUMBER of rates depending on cart and country — a column grid built for three looks broken
       with one. */
    /* Fastest means the earliest LATEST day, not the earliest earliest.
       Priority [1,2] and Express [1,1] share a minimum, so comparing minimums alone made a tie and
       kept whichever came first — the sheet announced "Arrives 28 Aug - 31 Aug, fastest: Priority"
       while Express beside it said 28 Aug. Compare the upper bound first: that is the date the
       customer is actually promised. */
    var fastest = rates.slice().sort(function(a, b){
      var A = a.delivery_days || [99, 99], B = b.delivery_days || [99, 99];
      var au = A[A.length - 1], bu = B[B.length - 1];
      return au !== bu ? au - bu : A[0] - B[0];
    })[0];

    /* Order: the answer first, then the control that changes it. The picker sat above the date,
       so the first thing in the sheet was a form field rather than the estimate. */
    var html = "";
    if (fastest) {
      /* Whichever country is selected. The row and the sheet answer for the same destination, so
         a customer who picks Bahrain sees Bahrain's date in both places rather than the sheet
         saying one thing and the row above it another. */
      LEAD_DATE = whenText(fastest.delivery_days, fastest.name);
      LEAD_RATE = fastest; publishState(); paintRowDate();
      /* One lead sentence, in plain words, before the table repeats it in columns. The earlier
         version stated the date, then the service, then both again in the row — this states the
         promise once and lets the table carry the comparison. */
      var sheetDate = whenText(fastest.delivery_days, fastest.name);
      /* The title states the answer — "Delivery Mon 31 Aug" — and the line under it says what that
         date is measured from. The date is the SHEET's (the selected country), because that is what
         the cards below it are about; the cart row keeps quoting the visitor's own market. */
      /* Document-wide, not box.parentElement: the heading is a sibling several levels above the
         container we render into, so scoping to the parent found nothing and the title never
         changed. Only the sheet carries this class. */
      var titles = document.querySelectorAll(".ntf-ship-title");
      /* No date is "" (see whenText). The asterisk is punctuation, so it stays out of the string -
         the same asterisk the footnote answers. "Delivery information" is the key the server
         renders this title with, so the two can never disagree. */
      var titleTxt = sheetDate
        ? shipT('ship-delivery-date', 'Delivery %date%', { date: sheetDate }) + "*"
        : shipT('delivery-information', 'Delivery information');
      for (var t = 0; t < titles.length; t++) titles[t].textContent = titleTxt;
      /* The service goes in as the name printed on its card ("Express"). It was lowercased, which is
         an English habit, and a lowercase "express" inside a German sentence is simply wrong. */
      html += '<p class="ntf-ship-fine">*' + esc(shipT('ship-estimate-fastest',
                'Estimate is based on our fastest %service% shipping option.',
                { service: svcLabel(fastest.name) })) + '</p>';
    }
    /* The sheet's own words - "Orders ship from our atelier in the Netherlands." at the top, the
       estimates note at the foot - come from the Shopify page "shipping-info" (29 Sept), so Kai edits
       them in admin; see pageSlot() below. */
    html += pageSlot("before");
    html += header();
    /* One card per service: what it is, when it lands, what it costs, and how close the cart is to
       making it free. The table said the same things in three columns, which reads fine on a laptop
       and badly on a phone, where "ARRIVES" and "COST" were competing for about 90px.

       Four states, driven entirely by the cart total against the zone's own thresholds:
         under the cheapest tier  every service priced, with the free-shipping threshold named
         under the free tier      every service priced, each bar showing how far along the cart is
         over the free tier       that service FREE and green, the faster one still to be earned
         over both                everything free, one line confirming it
       Nothing is hardcoded per country: the thresholds come from the compiled zone. */

    /* The threshold at which THIS service becomes free, or 0 if it never does in this zone. */
    function freeFrom(name){
      var short = shortName(name).toLowerCase();
      /* The table covers every zone, so it answers for the DESTINATION. */
      var z = zoneOf(ISO);
      if (z && z.f && z.f[short] != null) return z.f[short];
      if (!ZONE || !ZONE.methods) return 0;
      var best = 0;
      ZONE.methods.forEach(function(m){
        if (m.p !== 0) return;
        if (shortName(m.n).toLowerCase() !== short) return;
        if (!best || m.from < best) best = m.from;
      });
      return best;
    }
    /* The threshold's own currency. The rates beside it are quoted in the shop's currency, so a
       GB threshold reads "£64" — the number the profile actually holds — rather than being
       silently relabelled as euros. */
    function freeCur(){ var z = zoneOf(ISO); return (z && z.c) || "EUR"; }
    /* Can this cart's total be measured against this zone's threshold? Only if they are the same
       money. This used to ask "is it the detected country?", which is a narrower question with the
       same intent — and it silently denied every other euro country a progress bar. */
    function comparable(){
      var cartCur = (window.Shopify && Shopify.currency && Shopify.currency.active) || null;
      if (!cartCur) return ISO === DETECTED;      // no answer available: fall back to the old test
      return freeCur() === cartCur;
    }

    /* Express earns the bolt; everything else the van. Inline so there is no request and no
       dependency on the theme's icon set, which does not carry either of these. */
    function icon(name){
      if (shortName(name).toLowerCase().indexOf("express") >= 0) {
        return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
             + ' stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L4.5 13H11l-1 9 8.5-11H12l1-9z"/></svg>';
      }
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"'
           + ' stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h10v9H3z"/>'
           + '<path d="M13 9h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/>'
           + '<circle cx="17" cy="17.5" r="1.6"/></svg>';
    }

    html += '<div class="ntf-sc-list">';
    rates.forEach(function(r, rIdx){
      var price = r.compiled ? NaN : parseFloat(r.price);
      var free  = price === 0;
      var thr   = freeFrom(r.name);
      /* The threshold is compiled out of the delivery profile in the profile's OWN money — EUR for
         every zone but GB and US — so a Swedish cart read "Free from €100" beside an announcement
         bar, a product line and a reward ladder that all said 1,150 kr. One fact, two currencies,
         on one screen. It now goes through the same converter the ladder uses (NTF_SHIP_CONVERT in
         ntf-cart.js), which rounds UP: engineering rule 2, the figure shown is never lower than the
         one checkout enforces.

         Only for the DETECTED country. Shopify.currency.rate turns the SHOP's money into the
         customer's and says nothing about a zone the customer merely picked from the list to
         compare — nor about GB's pounds seen from a Swedish cart — so those keep printing the
         number the profile actually holds, as before.

         Converting also makes the threshold COMPARABLE to the cart total, which is already in the
         customer's currency. That is why the Swedish card had no progress bar and no "Spend X
         more": comparable() asks whether the two are the same money, and until now they were not. */
      var thrCur = freeCur(), thrLocal = false;
      /* Convert whenever the zone's condition is written in the SHOP's currency, which is every zone
         but GB and US — not only for the country the customer was detected in.

         The first version of this gated on ISO === DETECTED, on the reasoning that the market rate
         says nothing about a country merely picked from the list. Testing the dropdown showed why
         that was wrong: from a USD cart, picking Sweden gave rates in dollars and "Free from €300"
         beside them. Two currencies on one screen again — the exact thing this fix existed to stop,
         just moved into the compare path. The customer is charged in their own money whatever the
         destination, so their own money is the honest way to state any zone's threshold.

         GB (GBP) and US (USD) zones are the exception and stay unconverted: Shopify.currency.rate
         converts the SHOP's money, so applying it to a pound threshold would invent a number. Those
         two are only ever the DETECTED zone from their own markets, where the rate is 1 and nothing
         needs converting anyway; seen from elsewhere they keep the figure the profile holds. */
      if (thr > 0 && thrCur === "EUR" && typeof window.NTF_SHIP_CONVERT === "function") {
        var thrCents = window.NTF_SHIP_CONVERT(thr, thrCur);
        if (thrCents != null) { thr = thrCents / 100; thrLocal = true; }
      }
      var cmp = thrLocal || comparable();
      function thrMoney(v){ return thrLocal ? fmtLocalThr(v) : fmtMoney(v, thrCur); }
      /* The date, not "2-3 business days". A weekday and a date answer "before Saturday?"; a
         count of business days asks the customer to work it out with a calendar. */
      var when  = whenText(r.delivery_days, r.name);
      /* Only where the two are the same money: a bar drawn across a euro cart and a pound
         threshold would be a made-up number. */
      var pct   = free ? 100 : (thr > 0 && !r.compiled && cmp
                    ? Math.max(3, Math.min(100, Math.round(total / thr * 100))) : 0);
      html += '<div class="ntf-sc' + (free ? ' is-free' : '') + '">'
           +    '<div class="ntf-sc-top">'
           +      '<span class="ntf-sc-icon">' + icon(r.name) + '</span>'
           +      '<span class="ntf-sc-body">'
           +        '<span class="ntf-sc-line"><b>' + esc(svcLabel(r.name)) + '</b></span>'
           +        '<span class="ntf-sc-cut">' + esc(orderWithin(r.name)) + '</span>'
                    /* No date is "", not the English "At checkout" this used to compare against. */
           +        '<span class="ntf-sc-when">' + esc(when
                      ? shipT('ship-arrives', 'Arrives %date%', { date: when })
                      : shipT('ship-confirmed-at-checkout', 'Confirmed at checkout')) + '</span></span>'
           +      (r.compiled ? ''
                   : free ? '<span class="ntf-sc-pill">' + esc(shipT('free-badge', 'FREE')) + '</span>'
                          /* A RATE from /cart/shipping_rates.json, quoted in the money the
                             customer is charged in — fmtMoney with no currency stamped a euro
                             sign on it, so a Swedish express rate read "€215,76" and a Japanese
                             one "€6001". Same formatter as the totals row, so the two agree. */
                          : '<span class="ntf-sc-price">' + fmtLocal(price) + '</span>')
           +    '</div>'
           +    (thr > 0
                  ? '<div class="ntf-sc-note">'
                    /* The threshold and the distance to it belong on one line: "Free from EUR 75"
                       alone makes the customer do the subtraction, and a separate banner saying
                       "spend EUR 6 more" made them look in two places for one fact. The gap is
                       only stated for the DETECTED country — the compiled thresholds say nothing
                       about a country picked from the list to compare. */
                    + (free ? esc(shipT('ship-free-unlocked', 'Free shipping unlocked'))
                            : esc(shipT('ship-free-from', 'Free from %amount%', { amount: thrMoney(thr) }))
                              + (!r.compiled && cmp && thr > total
                                   ? ' — ' + esc(shipT('ship-spend-more', 'Spend %amount% more',
                                                       { amount: thrMoney(thr - total) }))
                                   : ''))
                    + '</div>'
                  : '')
           +  '</div>';
    });
    html += '</div>';

    /* No closing banner. It restated, in its own yellow box, what each card's own note now says
       on the line that states the threshold — and it could only ever talk about one service, so
       the other card sat there with an unanswered number on it. */
    html += dutyLine() + pageSlot("after");
    box.innerHTML = html;
    wire(box);
    if (window.NTF_PAGE) window.NTF_PAGE.fill(box);
  }

  /* ---- The sheet's static words live in a Shopify page (29 Sept) -------------------------------

     Page "shipping-info", written and translated in Shopify admin, split at its {rates} placeholder:
     what stands before it goes above the country picker, what follows it replaces the estimates note
     at the foot. Every surface shows the same words - the product drawer, the cart drawer, the cart
     page. The dynamic parts stay here: dates, rates, thresholds, the duties line.

     Read only from the cache (NTF_PAGE.peek): the page is fetched on INTENT - a tap or hover on a
     door to this sheet, snippets/ntf-info-drawer.liquid - never because a sheet rendered, and a sheet
     renders at every product page load. Until it has arrived, the foot shows the note from the locale
     files, as before, and the top shows nothing; ntf:page then fills every mounted sheet in place. */
  function pageParts(){
    var P = window.NTF_PAGE && window.NTF_PAGE.peek("shipping-info");
    if (!P) return null;
    var t = document.createElement("template"), before = document.createElement("div"),
        after = document.createElement("div"), past = false;
    t.innerHTML = P.html;
    var slot = t.content.querySelector('[data-ntf-slot="rates"]');
    Array.prototype.slice.call(t.content.childNodes).forEach(function(n){
      if (n === slot) { past = true; return; }
      (past ? after : before).appendChild(n);
    });
    return { before: before.innerHTML.trim(), after: after.innerHTML.trim() };
  }
  function pageSlot(part){
    var P = pageParts(), v;
    if (part === "before") v = P ? P.before : "";
    else v = P ? P.after : esc(shipT('ship-estimates-note',
      'Delivery estimates are based on historical averages and are not guaranteed. Remote areas, islands, carrier delays and peak periods can add time. Please select your preferred shipping method during checkout.'));
    return '<div class="' + (part === "before" ? "ntf-ship-intro" : "ntf-ship-note") + '" data-ntf-pg="' + part + '"'
         + (v ? '' : ' hidden') + '>' + v + '</div>';
  }
  window.addEventListener("ntf:page", function(e){
    if (!e.detail || e.detail.key !== "shipping-info") return;
    var P = pageParts(), s = document.querySelectorAll(".ntf-ship [data-ntf-pg]");
    if (!P || !s.length) return;
    for (var i = 0; i < s.length; i++) {
      var v = s[i].getAttribute("data-ntf-pg") === "before" ? P.before : P.after;
      if (s[i].innerHTML !== v) s[i].innerHTML = v;
      s[i].hidden = !v;
    }
    if (window.NTF_PAGE) window.NTF_PAGE.fill(document);
  });


  /* ---- The country list on a pointer device ---------------------------------------------------

     Kai, 24 Sept: "when clicking on it on desktop it pops up upward instead of downward." A native
     <select> popup is placed by the BROWSER, which puts the selected option over the control - so
     with 190 countries and one picked deep in the list it opens upward and covers the sheet, with
     clear space underneath it. No CSS property and no script can move it; the only way to control
     where the list appears is not to use the native one.

     So on a pointer device the native popup is suppressed (pointer-events:none on the select, in
     ntf-cart.css) and this panel is drawn under the field. TOUCH keeps the native picker
     untouched: the OS wheel has no keyboard, no layout shift and no scroll-commit bug, and getting
     it is exactly why this field was rebuilt onto a select in the first place.

     Choosing writes to the select and fires a real change event, so the re-quote, the localStorage
     write and the ntf:ship-country announcement all run through the code that already existed -
     there is one country-change path, not two. */
  /* Our own list on every screen 768px or wider, and on a narrower window that has a mouse or
     trackpad. Only a phone keeps the OS picker - the one place the native control is the better one.
     Pointer detection alone was not enough (Kai, 25 Sept, twice): a Windows laptop with a
     touchscreen can report no fine pointer at all - the measured "desktop with touch" profile
     answered false to BOTH (pointer:fine) and (any-pointer:fine) - and then Chrome's NATIVE list
     came back, sized to the longest country name, spilling past the field's edges and off the bottom
     of the screen. Width is something that machine cannot misreport. */
  /* 11 Oct 2026 (Kai: "the one from the menu is a lot better than the one we have now in the drawer"): the
     list below is now used on EVERY device, phones included, styled like the country list in the phone menu.
     Phones had the system picker until today. The three faults that once sent phones to the system picker
     belonged to an older combobox and are not in this list: it is positioned over the sheet instead of in its
     flow, it commits on click (a scroll gesture never fires one), and it holds every country.
     The job is unchanged: it only changes the country the shipping quote is for, never the shop's market. */
  function finePointer(){ return true; }
  /* A phone's browser resizes the window whenever its toolbar slides, which happens while the list is being
     scrolled; only a change of WIDTH (rotation, a real resize) closes the list. */
  var MENU_W = 0;
  function onMenuResize(){ if (MENU && window.innerWidth !== MENU_W) closeMenu(); }
  var MENU = null, TYPED = "", TYPED_AT = 0;
  function menuOpts(){ return MENU ? MENU.el.querySelectorAll(".ntf-ship-opt") : []; }
  function menuActive(i){
    var o = menuOpts(); if (!o.length) return;
    if (i < 0) i = 0; if (i > o.length - 1) i = o.length - 1;
    for (var k = 0; k < o.length; k++) o[k].classList.toggle("is-active", k === i);
    MENU.i = i;
    var el = o[i], top = el.offsetTop, bot = top + el.offsetHeight;
    if (top < MENU.el.scrollTop) MENU.el.scrollTop = top;
    else if (bot > MENU.el.scrollTop + MENU.el.clientHeight) MENU.el.scrollTop = bot - MENU.el.clientHeight;
  }
  /* noFocus: when the field is about to be replaced, handing it focus on the way out only strands
     focus on a node that is leaving the page. */
  function closeMenu(noFocus){
    if (!MENU) return;
    var m = MENU; MENU = null;
    if (m.el.parentNode) m.el.parentNode.removeChild(m.el);
    m.where.setAttribute("aria-expanded", "false");
    document.removeEventListener("mousedown", onDocDown, true);
    document.removeEventListener("keydown", onMenuKey, true);
    window.removeEventListener("resize", onMenuResize);
    if (noFocus !== true) { try { m.where.focus({ preventScroll: true }); } catch(e){} }
  }
  function onDocDown(e){
    if (!MENU) return;
    if (!MENU.where.isConnected) { closeMenu(true); return; }
    if (MENU.el.contains(e.target) || MENU.where.contains(e.target)) return;
    closeMenu();
  }
  function commitMenu(iso){
    if (!MENU) return;
    var sel = MENU.sel;
    closeMenu();
    if (!iso || sel.value === iso) return;
    fillOptions(sel);
    sel.value = iso;
    sel.dispatchEvent(new Event("change", { bubbles: true }));
  }
  function onMenuKey(e){
    if (!MENU) return;
    if (!MENU.where.isConnected) { closeMenu(true); return; }
    var k = e.key;
    if (k === "Escape"){ e.preventDefault(); closeMenu(); return; }
    if (k === "ArrowDown"){ e.preventDefault(); menuActive(MENU.i + 1); return; }
    if (k === "ArrowUp"){ e.preventDefault(); menuActive(MENU.i - 1); return; }
    if (k === "Home"){ e.preventDefault(); menuActive(0); return; }
    if (k === "End"){ e.preventDefault(); menuActive(menuOpts().length - 1); return; }
    if (k === "Enter" || k === " "){
      e.preventDefault();
      var o = menuOpts()[MENU.i];
      commitMenu(o && o.getAttribute("data-iso"));
      return;
    }
    /* Type-to-jump, because the native list has it and losing it on a 190-row list would be a
       downgrade. Same ~900ms buffer the platform uses. */
    if (k && k.length === 1 && /\S/.test(k)){
      var now = +new Date();
      TYPED = (now - TYPED_AT < 900) ? TYPED + k : k;
      TYPED_AT = now;
      var o2 = menuOpts(), q = TYPED.toLowerCase();
      for (var i = 0; i < o2.length; i++){
        if ((o2[i].textContent || "").toLowerCase().indexOf(q) === 0){ menuActive(i); break; }
      }
    }
  }
  /* The box the list can actually be seen in: every ancestor that clips or scrolls, intersected,
     capped by the viewport. In the drawer the field sits inside a scrolling panel, and testing the
     viewport alone said "plenty of room below" while the panel's own edge cut the list off
     (review, 25 Sept). */
  function clipBox(el){
    var top = 0, bottom = window.innerHeight;
    for (var n = el.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement){
      var ov = getComputedStyle(n).overflowY;
      if (ov === "auto" || ov === "scroll" || ov === "hidden" || ov === "clip"){
        var b = n.getBoundingClientRect();
        if (b.top > top) top = b.top;
        if (b.bottom < bottom) bottom = b.bottom;
      }
    }
    return { top: top, bottom: bottom };
  }
  function openMenu(where, sel){
    if (MENU && MENU.where === where){ closeMenu(); return; }
    closeMenu();
    var el = document.createElement("div");
    el.className = "ntf-ship-menu";
    el.setAttribute("role", "listbox");
    var html = "", at = 0;
    for (var i = 0; i < COUNTRIES.length; i++){
      var c = COUNTRIES[i], on = c.iso === sel.value;
      if (on) at = i;
      html += '<button type="button" class="ntf-ship-opt' + (on ? " is-on" : "") + '" role="option"'
            + ' aria-selected="' + (on ? "true" : "false") + '" data-iso="' + c.iso + '">'
            + c.name + '</button>';
    }
    el.innerHTML = html;
    where.appendChild(el);
    where.setAttribute("aria-expanded", "true");
    MENU = { el: el, where: where, sel: sel, i: at };
    /* Down by default, and up ONLY when the field genuinely has no room below it AND more above.
       That test is the entire fix: the native popup flipped up with the whole page empty
       underneath, because it was positioning the SELECTED ROW rather than the list. */
    var r = where.getBoundingClientRect(), h = el.offsetHeight, cb = clipBox(where);
    var below = cb.bottom - r.bottom, above = r.top - cb.top;
    if (below < h + 12 && above > below) el.classList.add("is-up");
    /* And never taller than the side it opened on, so a short panel shows a shorter list rather
       than a clipped one. 160px is the floor: below that it is a peephole, not a list. */
    var room = el.classList.contains("is-up") ? above : below;
    if (room - 8 < h) el.style.maxHeight = Math.max(160, Math.round(room - 8)) + "px";
    /* 11 Oct 2026 (Kai, on his iPhone: the list "is below the got it button ... akwardly behind it"): a list
       that opens downwards ends above the panel's "Got it" button, and if it is still partly out of view the
       panel scrolls just enough to show it whole. */
    if (!el.classList.contains("is-up")){
      var dlg = where.closest ? where.closest("[role='dialog'], .ntf-fpanel, .ntf-pdel-drawer") : null;
      var ok = dlg ? dlg.querySelector(".ntf-fdet-ok") : null;
      if (ok){
        var ot = ok.getBoundingClientRect().top, mr = el.getBoundingClientRect();
        if (ot > r.bottom && mr.bottom > ot - 8) el.style.maxHeight = Math.max(160, Math.round(ot - 8 - mr.top)) + "px";
      }
    }
    try { el.scrollIntoView({ block: "nearest" }); } catch (e) {}
    menuActive(at);
    if (el.children[at]) el.scrollTop = Math.max(0, el.children[at].offsetTop - el.clientHeight / 2);
    el.addEventListener("click", function(e){
      var o = e.target && e.target.closest ? e.target.closest(".ntf-ship-opt") : null;
      if (!o) return;
      e.preventDefault(); e.stopPropagation();
      commitMenu(o.getAttribute("data-iso"));
    });
    document.addEventListener("mousedown", onDocDown, true);
    document.addEventListener("keydown", onMenuKey, true);
    MENU_W = window.innerWidth; window.addEventListener("resize", onMenuResize);
  }
  function wireMenu(box, sel){
    var where = box.querySelector(".ntf-ship-where");
    if (!where || !finePointer()) return;
    where.classList.add("ntf-ship-where--menu");
    /* Only here, not in header(): on a touch device the native select stays the focusable control
       (review, 25 Sept - an iPad with a keyboard was tabbing onto a dead div and past the select). */
    where.setAttribute("tabindex", "0");
    sel.setAttribute("tabindex", "-1");
    where.addEventListener("click", function(e){
      if (e.target && e.target.closest && e.target.closest(".ntf-ship-menu")) return;
      e.preventDefault();
      openMenu(where, sel);
    });
    where.addEventListener("keydown", function(e){
      if (MENU) return;                                  // onMenuKey owns the keyboard once open
      if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown"){
        e.preventDefault(); openMenu(where, sel);
      }
    });
  }

  function wire(box){
    var sel = box.querySelector("select.ntf-ship-country");
    if (!sel) return;
    /* Capture phase, so the options are in before the native picker opens (see fillOptions). */
    var lazyOn = box.querySelector(".ntf-ship-where") || sel;
    ["pointerdown", "touchstart", "mousedown", "focusin", "keydown"].forEach(function(n){
      lazyOn.addEventListener(n, function(){ fillOptions(sel); }, { capture: true, passive: true });
    });
    wireMenu(box, sel);
    sel.addEventListener("change", function(){ applyCountry(sel.value, true); });
  }
  /* One path for a country change, whichever control made it. The select's handler and the
     listener below carried the same six lines and had already drifted - only one of them
     announced (review, 25 Sept). */
  function applyCountry(iso, announce){
    if (!iso || iso === ISO) return;
    ISO = iso;
    try { sessionStorage.setItem("ntfShipCountry", ISO); } catch(e){}
    closeMenu(true);                     // it belongs to a sheet that is about to be replaced
    /* EVERY mounted sheet, not just the one whose dropdown was used.
       snippets/ntf-product-delivery.liquid renders two mount points, so a product page carries two
       sheets; reloading only one left the other showing the previous country's rates and
       thresholds. Measured: switching to SE repainted the first to "Free from US$ 360" while the
       second still read "Free from $300". Which of the two a customer sees depends on which
       disclosure they open, so both have to follow. */
    var boxes = document.querySelectorAll(".ntf-ship");
    for (var i = 0; i < boxes.length; i++){
      boxes[i].textContent = shipT('ship-checking', 'Checking shipping options\u2026');
      load(boxes[i]);
    }
    reprimeRow();
    /* Announced, so the product page's own drawer follows without a reload. ntf-cart.js listens
       too: the rewards ladder's free-shipping rung is the new country's threshold now. */
    if (announce) window.dispatchEvent(new CustomEvent("ntf:ship-country", { detail:{ iso: ISO, from: "sheet" } }));
  }
  /* ...and followed: a country picked in the product page's drawer re-quotes every mounted sheet.
     Our own announcements are ignored - applyCountry has already done the work. */
  window.addEventListener("ntf:ship-country", function(e){
    var d = e.detail || {};
    if (d.from === "sheet") return;
    applyCountry(d.iso, false);
  });
  function fail(box){
    dropMenuIn(box);
    /* Reached when Shopify returns no rate for this country and cart. The duties line is not about
       rates, so it still applies here — it is the reassurance an international customer most wants
       exactly when the price is not shown. */
    box.innerHTML = header()
      + dutyLine()
      + '<p class="ntf-ship-err">'
      + esc(shipT('ship-rates-error', 'We could not load live rates for this country. Your options and costs are shown at checkout.'))
      + '</p>';
    wire(box);
  }

  /* A made-to-order line changes the answer entirely: nothing in the cart ships on a normal transit
     time, so quoting a date from Shopify rates would be wrong for the whole order.

     Free gifts are excluded deliberately — a gift is picked from stock and never the reason an order
     is custom. Matched on the variant/option text rather than a product list, so a new made-to-order
     product needs no code change. */
  function hasCustomLine(cart){
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.price) continue;                       // free gift
      if (it.properties && it.properties._Gifted) continue;
      // Exact match on the option values, no regex.
      // The previous version used a word-boundary regex and the generator wrote LITERAL BACKSPACE bytes
      // where the escapes belonged, so it tested for "<BS>custom<BS>" and never matched. grep shows
      // nothing wrong because a backspace is invisible in terminal output.
      /* "CUSTOM" is the option value as it is entered in admin, and it only matches because /cart.js
         is fetched WITHOUT a locale prefix: /nl/cart.js answers with translated option values
         (measured 25 Sept - "Default Title" comes back as "Standaardtitel"). Keep both cart
         fetches in this file unprefixed. */
      var vals = [it.variant_title || ""].concat((it.options_with_values || [])
        .map(function(o){ return o.value; }));
      for (var k = 0; k < vals.length; k++) {
        if (String(vals[k]).trim().toUpperCase() === "CUSTOM") return true;
      }
    }
    return false;
  }

  /* One request per destination and cart total, however many callers ask at once. primeRowDate()
     and every mounted sheet's load() asked for the same key at the same instant on every page load
     and every pick - cache[] only fills when an answer lands, so none of them could see the
     others' request in flight (review, 25 Sept: two identical calls 1ms apart, measured).
     Resolves to the rates sorted by price, or null when Shopify returns none. */
  var inflight = {};
  function ratesFor(iso, cents){
    var key = iso + "|" + cents;
    if (cache[key]) return Promise.resolve(cache[key]);
    if (inflight[key]) return inflight[key];
    /* The ISO code, in the country FIELD. (A separate country_code parameter is accepted and then
       ignored, so it silently quoted the wrong place - that is still true and is not what this is.)

       Not the country NAME any more. The names come from localization.available_countries, which
       Shopify prints in the visitor's language now that Weglot is off, and this endpoint only knows
       English ones: "Nederland", "Deutschland", "Frankrijk" all answer 422 "Country/region not
       supported", so every /nl, /de and /fr cart fell back to the compiled table - no prices, no
       "spend X more", no shipping in the total. Measured 25 Sept against the live endpoint: the
       code and the English name give identical answers for all 236 countries. */
    var q = "shipping_address[country]=" + encodeURIComponent(iso);
    if (ZIP[iso])  q += "&shipping_address[zip]=" + encodeURIComponent(ZIP[iso]);
    if (PROV[iso]) q += "&shipping_address[province]=" + encodeURIComponent(PROV[iso]);
    var pr = fetch("/cart/shipping_rates.json?" + q, {headers:{Accept:"application/json"}})
      .then(function(r){ return r.json(); })
      .then(function(res){
        delete inflight[key];
        if (!res.shipping_rates || !res.shipping_rates.length) return null;
        res.shipping_rates.sort(function(a,b){ return parseFloat(a.price) - parseFloat(b.price); });
        fillDays(res.shipping_rates);
        cache[key] = res.shipping_rates;
        return res.shipping_rates;
      }, function(err){ delete inflight[key]; throw err; });
    inflight[key] = pr;
    return pr;
  }

  function load(box){
    fetch("/cart.js?_=" + Date.now(),{headers:{Accept:"application/json"},cache:"no-store"})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (hasCustomLine(cart)) { renderCustom(box); return; }
        if (!cart.item_count){
          var cr0 = compiledRates(ISO);
          if (cr0.length){ render(box, cr0, 0); return; }
        }
        var total = cart.total_price/100, iso = ISO;
        return ratesFor(iso, cart.total_price).then(function(rates){
          /* Answered for a country the customer has since moved away from. The load() started
             for the new country owns this box now; painting this answer would put the old
             country's rates back over it. */
          if (iso !== ISO) return;
          if (!rates) {
            var cr1 = compiledRates(ISO);
            if (cr1.length){ render(box, cr1, total); return; }
            fail(box); return;
          }
          render(box, rates, total);
        });
      })
      .catch(function(){ fail(box); });
  }

  function mount(){
    /* The cart page and the drawer render this popup with DIFFERENT markup, which is why anchoring
       on one selector mounted the sheet on one surface and silently not the other:
         cart page  <details class="ntf-fdet ntf-fdet--deliv">        (no .ntf-fdet-body)
         drawer     a panel containing <p data-ntf-deliv>Delivery</p> (no .ntf-fdet--deliv)
       Both are matched, and the sheet goes in just before whatever acknowledge button the panel has. */
    var panels = [];
    /* Only if the body is INSIDE it. On the cart page the disclosure and its panel are siblings,
       so this element has nothing to insert after — and taking it anyway put the sheet inside a
       collapsed <details> and made the real panel look already-mounted. */
    document.querySelectorAll(".ntf-fdet--deliv").forEach(function(el){
      if (el.querySelector(".ntf-fdet-body")) panels.push(el);
    });
    document.querySelectorAll("[data-ntf-deliv]").forEach(function(el){
      // Climb only a few levels, and only while a popup body is in reach. An unbounded climb walked
      // all the way to <html> on the cart page, put the sheet outside <body> where it is invisible,
      // and — because <html> contains everything — made every later "already mounted?" check pass,
      // so the real panel never got one.
      var panel = el.parentElement, hops = 0;
      while (panel && hops < 4 && !panel.querySelector(".ntf-fdet-body")) {
        panel = panel.parentElement; hops++;
      }
      if (!panel || panel === document.body || panel === document.documentElement) return;
      if (!panel.querySelector(".ntf-fdet-body")) return;
      if (panels.indexOf(panel) < 0) panels.push(panel);
    });

    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      if (!panel || panel.querySelector(".ntf-ship")) continue;
      var box = document.createElement("div");
      box.className = "ntf-ship";
      box.textContent = shipT('ship-checking', 'Checking shipping options\u2026');
      var body = panel.querySelector(".ntf-fdet-body");
      var btn = panel.querySelector(".ntf-fdet-ok, button, .button");
      var row = btn ? (btn.closest(".flex") || btn) : null;
      if (body && body.parentNode) body.parentNode.insertBefore(box, body.nextSibling);
      else if (row && row.parentNode === panel) panel.insertBefore(box, row);
      else panel.appendChild(box);
      load(box);
      stripBlockCopy();
    }
  }
  /* Rates depend on the cart total, so a cart change invalidates everything shown. */
  document.addEventListener("eurus:cart:items-changed", function(){
    cache = {};
    var old = document.querySelectorAll(".ntf-ship");
    for (var i=0;i<old.length;i++) old[i].parentNode.removeChild(old[i]);
    /* The QUOTE is stale too, not just the cache. Clearing the cache alone left the row showing
       the old price — "Free" on a cart that had just dropped below the threshold — because
       primeRowDate() returns early while LEAD_DATE is set, so nothing ever asked again. */
    SHIP_COST = null;
    LEAD_DATE = "";
    /* Un-settle for the duration of the re-quote. Left true from the previous run, stripBlockCopy
       reads it as "settled, and no date at all" and un-hides the theme's own heading for the
       ~400ms until the new rates land — a flash of the wrong copy on every cart change. */
    RATES_SETTLED = false;
    publishState();
    setTimeout(function(){ mount(); primeRowDate(); }, 400);
  });
  NTF_ON_MUTATE(mount);
  mount();

  /* Design A: the block's own heading and intro are removed so the sheet is the only voice.

     Setting textContent was not enough. Those elements are Alpine-bound, so the date is written
     back on the next render and the popup returned to "Delivery August 28" above a paragraph
     naming the same service and country the table states. A CLASS survives that: Alpine rewrites
     text, not the class list, and the rule below is !important so inline styles cannot win either.

     Matched on a MARKER, data-ntf-blockcopy, rendered on the paragraph itself. It was matched on
     TEXT until 2026-09-14 — the argument for that being three different markups for this popup
     (cart details, drawer panel, mobile bottom sheet) which class targeting cleaned only two of.
     The marker reaches all three and costs one attribute per surface, and matching English text
     was breaking every other language (see the note in stripBlockCopy).

     Re-applied on the shared mutation observer, so a re-render that replaces the element outright
     is caught on the next frame. */
  /* The row that opens this popup showed the block's own date, which design A hides. Hiding it
     without replacing it left the row as a bare icon, so the customer lost the estimate entirely.
     Our date goes back in its place, from the same rates the sheet quotes. */
  var LEAD_DATE = "";
  var LEAD_RATE = null;   // the rate LEAD_DATE came from, for the published cut-off
  /* The totals row says "Shipping  Free"; the row under it says "Delivery 31 Aug". Same fact,
     two places, presented as if unrelated. The date joins the money it belongs to. */
  /* Cart total in euros, read from the markup rather than fetched: the Klarna line carries it in
     cents and is re-rendered with the cart, so it is current without a request of our own. */
  function cartTotal(){
    var el = document.querySelector(".ntf-klarna-inline[data-total]")
          || document.querySelector("[data-cr-row][data-pay]");
    var v = el && (el.getAttribute("data-total") || el.getAttribute("data-pay"));
    return v ? parseFloat(v) / 100 : null;
  }
  /* "Shipping — Free" stated on a cart that has not reached the threshold is simply wrong: that
     cart pays for shipping. Below it, the row is hidden and the total speaks for itself. */
  /* What this cart actually pays for shipping: the cheapest rate we were quoted. "Free" when it is
     free, the amount when it is not — the row used to say Free unconditionally, which was simply
     untrue below the threshold, and hiding it there left a cart silently unpriced.

     It is also the second door to the sheet: the price is exactly the thing someone wants to
     interrogate, so tapping it opens the same popup. The delivery row's own button is clicked
     rather than the Alpine store being set directly, so whatever the theme does on open still
     happens. */
  var SHIP_COST = null;   // null = not quoted yet; the row keeps its rendered value until then
  function paintShipRow(){
    var rows = document.querySelectorAll(".ntf-ship-row");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      row.style.display = "";
      var val = row.querySelector(".ntf-ship-val");
      if (val && SHIP_COST !== null) {
        // Same asterisk as the delivery estimate: it points at the sheet this row opens.
        var txt = SHIP_COST === 0 ? shipT('free', 'Free') + "*" : fmtLocal(SHIP_COST);
        if (val.textContent.trim() !== txt) val.textContent = txt;
        val.classList.toggle("is-free", SHIP_COST === 0);
      }
      if (!row.getAttribute("data-ntf-open")) {
        row.setAttribute("data-ntf-open", "1");
        row.style.cursor = "pointer";
        row.addEventListener("click", function(e){
          /* Drawer: set Alpine's own state directly rather than relaying a synthetic click on
             .ntf-deliv-btn. A real click on that button works fine — but .click() dispatches a
             SECOND click event that also bubbles to document, where Alpine's own
             @click.away="...openField = false" on the delivery panel (snippets/cart-drawer.liquid)
             sees a click landing outside the panel and closes it again, within the same handler
             that just opened it. Setting the store's field directly never fires a click at all, so
             that listener has nothing to react to. (Kai, 18 Sept: "click to open, immediately
             closes again" — this was it.) */
          if (window.Alpine && window.Alpine.store && document.querySelector(".ntf-deliv-btn")) {
            e.stopPropagation();
            var helper = window.Alpine.store("xCartHelper");
            if (helper) { helper.openField = (helper.openField === "ntf_delivery") ? false : "ntf_delivery"; return; }
          }
          /* Cart page: no Alpine store for this, just the native <details> — a real relay click is
             fine here (see the stopPropagation note below, which still applies to this path). */
          var btn = document.querySelector(".ntf-fdet--deliv .ntf-fdet-sum");
          if (!btn) return;
          /* Stopped BEFORE the relayed click, not after: the relay opens the <details>
             synchronously, and ntf-cart.js has its own document-level listener that closes the
             delivery drawer on any click whose target is outside it. That listener runs later in
             the SAME bubble this click is still on — its target is this row, which is outside the
             delivery panel — so without this the panel opened and immediately closed again within
             one click (measured 18 Sept: .ntf-fdet--deliv[open] false right after). */
          e.stopPropagation();
          btn.click();
        });
      }
    }
  }
  /* The totals row answers "what does shipping cost", and nothing else. It carried the arrival
     date too, which duplicated the row below it and made a money line read as a date line. The
     date lives in the sheet, one tap away. */
  /* The Total, with shipping in it.

     Only the NUMBER inside the element is rewritten, not the element: the theme wraps it in a span
     the price apps hook, and replacing the markup would take that with it. The base comes from
     data-ntf-base, so this is idempotent — running it fifty times gives the same answer as once. */
  /* The instalment follows the Total, because Klarna charges what the Total says — including the
     shipping now folded into it. Thirds of the goods total alone sat directly under a different
     number and contradicted it. */
  function paintKlarna(){
    if (SHIP_COST === null) return;
    var rows = document.querySelectorAll(".ntf-klarna-inline[data-total] .ntf-klarna-text");
    for (var i = 0; i < rows.length; i++) {
      var el = rows[i];
      var host = el.closest(".ntf-klarna-inline");
      var base = parseFloat(host && host.getAttribute("data-total"));
      if (isNaN(base)) continue;
      var node = firstNumberNode(el);
      if (!node) continue;
      /* The "3" in "or 3x" is a number too, and it is not the one to rewrite. */
      if (!/[.,]\d/.test(node.nodeValue) && node.nodeValue.indexOf("3x") > -1) {
        node = nextNumberNode(el, node);
        if (!node) continue;
      }
      if (!el.dataset.ntfFmt) {
        var m = node.nodeValue.match(NUM_RE_AMT);
        if (m) el.dataset.ntfFmt = m[0];
      }
      var want = fmtLike(el.dataset.ntfFmt, (base / 100 + SHIP_COST) / 3);
      if (el.dataset.ntfShown === want) continue;
      node.nodeValue = node.nodeValue.replace(NUM_RE_AMT, want);
      el.dataset.ntfShown = want;
    }
  }
  /* The text node after the one given, still inside el, that carries a number. */
  function nextNumberNode(el, after){
    var walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), n, seen = false;
    while ((n = walk.nextNode())) {
      if (n === after) { seen = true; continue; }
      if (seen && /\d/.test(n.nodeValue)) return n;
    }
    return null;
  }

  /* Cents, straight from the cart. */
  function setTotalBase(cents){
    var vals = document.querySelectorAll(".ntf-total-val");
    for (var i = 0; i < vals.length; i++) vals[i].setAttribute("data-ntf-base", cents);
  }

  function paintTotal(){
    if (SHIP_COST === null) return;
    var vals = document.querySelectorAll(".ntf-total-val[data-ntf-base]");
    for (var i = 0; i < vals.length; i++) {
      var el = vals[i];
      var base = parseFloat(el.getAttribute("data-ntf-base"));
      if (isNaN(base)) continue;
      var node = firstNumberNode(el);
      if (!node) continue;
      /* The number the theme printed is the format sample — kept on the element, because after the
         first repaint the text on screen is ours and no longer says how the shop writes money. */
      if (!el.dataset.ntfFmt){
        var m = node.nodeValue.match(NUM_RE);
        if (m) el.dataset.ntfFmt = m[0];
      }
      var want = fmtLike(el.dataset.ntfFmt, base / 100 + SHIP_COST);
      if (el.dataset.ntfShown === want) continue;
      node.nodeValue = node.nodeValue.replace(NUM_RE, want);
      el.dataset.ntfShown = want;
    }
  }
  /* A money NUMBER inside a text node.

     Group separators are not always "." or ",". Shopify writes SEK as "1 118,00 kr" and de-CH as
     "1'118.00", and a class of only [\d.,] stopped at the first space: paintTotal matched the
     leading "1", replaced THAT with the new total and left the rest of the old one behind, so a
     Swedish cart over 1 000 kr showed its total as "1.118,00 118,00 kr". Every space Shopify might
     use is in the class — plain, non-breaking and narrow no-break — plus the apostrophe.

     The run must END on a digit. The space AFTER a number belongs to the currency, and eating it
     turned "100 kr" into "1.150kr" once before; the alternation's second branch is the single-digit
     case, which cannot end on anything else. */
  var NUM_RE = /\d[\d.,\u0020\u00a0\u202f']*\d|\d/;
  /* The same, refusing a number followed by a digit or an "x" — the "3" of "or 3x" is a number too
     and it is not the one to rewrite. */
  var NUM_RE_AMT = /\d[\d.,\u0020\u00a0\u202f']*\d(?![\dx])|\d(?![\dx])/;
  /* The text node carrying the amount — the currency code sits in a node of its own. */
  function firstNumberNode(el){
    var walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = walk.nextNode())) { if (/\d/.test(n.nodeValue)) return n; }
    return null;
  }
  /* The theme's own formatting, copied from a number it printed: 1.234,56 stays 1.234,56 and
     1,234.56 stays 1,234.56. Reading document.documentElement.lang instead got this wrong — it is
     "en" on this shop while the money filter formats Dutch. */
  function fmtLike(sample, v){
    var dec = ",", grp = ".";
    if (sample){
      /* Whichever separator comes last is the decimal one — unless it is followed by three digits
         and there is only one of it, which is a thousands group with no cents. */
      var lastC = sample.lastIndexOf(","), lastD = sample.lastIndexOf(".");
      if (lastC > lastD)      { dec = ","; grp = "."; }
      else if (lastD > lastC) { dec = "."; grp = ","; }
      var tail = sample.slice(Math.max(lastC, lastD) + 1);
      if (tail.length === 3 && lastC !== lastD) { dec = dec === "," ? "." : ","; grp = grp === "." ? "," : "."; }
      /* A group separator that is neither "." nor "," — SEK groups with a space, de-CH with an
         apostrophe. Copied back rather than swapped for a dot the shop never writes. Only counts
         when a digit follows it, so the gap between an amount and its currency is not mistaken
         for one. */
      var g = /[\u0020\u00a0\u202f'](?=\d)/.exec(sample);
      if (g) grp = g[0];
    }
    var neg = v < 0; v = Math.abs(v);
    var whole = Math.floor(v), cents = Math.round((v - whole) * 100);
    if (cents === 100){ whole += 1; cents = 0; }
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, grp);
    /* A round amount keeps no decimals (Kai, 24 Sept: "total and klarna in this situation still
       show .00"). This function rewrites the total and the Klarna line in place once a shipping
       cost is known, and it was appending ",00" unconditionally — so the moment it repainted, a
       total the server had correctly printed as "£372" came back as "£315,00" beside a subtotal
       that had no decimals at all. The sample it copies its separators from cannot tell it this,
       because a round sample has no decimal separator in it to copy. */
    if (cents === 0) return (neg ? "-" : "") + w;
    return (neg ? "-" : "") + w + dec + (cents < 10 ? "0" : "") + cents;
  }

  function paintShipEta(){
    paintShipRow();
    paintTotal();
    paintKlarna();
    /* The cart page renders its Delivery disclosure hidden and waits to be told there is a date.
       That used to be syncDelivery's job; it is now the fallback writer and returns early in the
       normal case, so the row was never revealed. Whoever HAS a date reveals it. */
    if (haveDate()) {
      var det = document.querySelector('.ntf-fdet--deliv');
      if (det && det.hidden) det.hidden = false;
    }
    var slots = document.querySelectorAll(".ntf-ship-eta");
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].textContent) slots[i].textContent = "";
    }
  }
  function paintRowDate(){
    paintShipEta();
    /* A zone with NO transit times has no date (whenText returns ""), and printing that absence as
       if it were one - it once read "Delivery At checkout" - looks like a broken template. The
       same guard is in paintShipEta; it belongs in both, because LEAD_DATE feeds three places and
       each one has to decide for itself what to do with no answer. Here: leave the theme's own
       line showing. */
    /* No date, nothing to paint. Visibility of the theme's own line is stripBlockCopy's job, not
       this function's — un-hiding it here would fight the next strip pass and flicker. */
    if (!haveDate()) {
      var stale = document.querySelectorAll(".ntf-ship-rowdate");
      for (var k = 0; k < stale.length; k++) {
        if (stale[k].parentElement) stale[k].parentElement.removeChild(stale[k]);
      }
      return;
    }
    /* Put the date somewhere VISIBLE.

       Both earlier attempts placed it inside, or as a child of, the element stripBlockCopy hides —
       so it inherited display:none and the row showed a bare truck icon with no date at all. The
       date now goes into the nearest ancestor that is NOT hidden, as a sibling of the hidden node,
       and the code refuses to attach to anything carrying the hide class. */
    if (!LEAD_DATE) return;
    function hiddenish(el){
      var n = el;
      while (n && n !== document.body) {
        if (n.classList && n.classList.contains("ntf-ship-hide")) return true;
        if (getComputedStyle(n).display === "none") return true;
        n = n.parentElement;
      }
      return false;
    }
    function place(anchor){
      /* Sibling of the hidden label, and ONLY if that label's own parent is visible.

         Walking up to the nearest visible ancestor sounded safe and was not: where the whole row
         was hidden it kept climbing and dropped a second "Delivery Aug 31" into a container at the
         bottom of the page, far from any cart row. If the immediate parent is not visible there is
         no sensible place for the date, so nothing is inserted at all. */
      var host = anchor.parentElement;
      if (!host || hiddenish(host)) return;
      if (host.querySelector(".ntf-ship-rowdate")) return;   // one per row
      var slot = document.createElement("span");
      /* summary__title is the theme class the "Order note" label beside this one uses, so the two
         controls in the row are set in the same type rather than one of them inheriting whatever
         the row happened to give it. */
      slot.className = "ntf-ship-rowdate summary__title text-center";
      /* No "Delivery" prefix: the truck icon to its left already says what this is, and the row is
         only 50% of the drawer width. The asterisk points at the sheet, where the footnote
         explains what the date is based on. */
      slot.textContent = LEAD_DATE + "*";
      host.insertBefore(slot, anchor.nextSibling);
    }
    var hidden = document.querySelectorAll(".ntf-ship-hide");
    for (var i = 0; i < hidden.length; i++) {
      var el = hidden[i];
      /* Its row already carries the date: skip before place() measures anything. */
      if (el.parentElement && el.parentElement.querySelector(":scope > .ntf-ship-rowdate")) continue;
      /* Skipped by its MARKER, not by its opening words. The old test read "estimated with",
         which on /nl is "Geschatte levertijd" — so on every non-English market it did not fire. */
      if (el.hasAttribute && el.hasAttribute("data-ntf-blockcopy")) continue;
      /* Never inside the sheet itself. The sheet's heading is a sibling of the copy we hide, so
         the date landed next to it as "Delivery 31 Aug" — directly above "Arrives 31 Aug", the
         same fact twice in one glance. The date belongs on the ROW that opens the sheet. */
      if (el.closest && el.closest('[x-show*="ntf_delivery"]')) continue;
      place(el);
    }
    /* The plain delivery label on the cart row, found by [data-ntf-deliv-slot] — a marker the
       drawer and the cart page both render.

       It used to be found by [data-ntf-deliv] filtered on textContent === "Delivery", which is the
       exact mistake CLAUDE.md's engineering rule 1 describes. Weglot serves /nl with that label
       already translated to "Levering" ("Lieferung" on /de, "Livraison" on /fr), so the test never
       matched and DUTCH, GERMAN AND FRENCH CUSTOMERS GOT NO DELIVERY DATE ON THE CART ROW — the
       store's home market included. Measured on the preview 2026-09-14: /cart showed
       "Delivery Wed Sep 16*", /nl/wagen showed "Levering" and nothing else.

       The text test existed only to keep the date off the delivery SHEET's title, which also
       carries data-ntf-deliv. That title has no -slot marker, so the filter is no longer needed. */
    var labels = document.querySelectorAll("[data-ntf-deliv-slot]");
    for (var L = 0; L < labels.length; L++) {
      /* Already painted with this date: nothing to do, and nothing to measure. hiddenish() reads the
         computed style of every ancestor, and this ran on every DOM change (25 Sept: ~33ms a pass on
         a phone-speed CPU, 297ms as the drawer opened). */
      var done = labels[L].querySelector(".ntf-ship-rowdate");
      if (done && labels[L].dataset.ntfDelivDate === LEAD_DATE) continue;
      if (hiddenish(labels[L])) continue;
      if (labels[L].closest && labels[L].closest("*:has(> .ntf-ship-rowdate)")) continue;
      /* The word itself goes once there is a date (Kai, 24 Sept: "remove the word delivery from
         here - the date and the shipping icon say enough"). The drawer's own slot has never
         printed it, for the reason written above it; this brings the cart page into line.

         The label's own text node is the TRANSLATED word, so it is stashed and blanked rather than
         matched on. Matching it is the exact mistake rule 1 describes, and it cost /nl, /de and
         /fr their delivery date once already. Stashed, so a switch to a market with no transit
         times puts the word back rather than leaving an unlabelled row. */
      var lead = null, kids = labels[L].childNodes;
      for (var n = 0; n < kids.length; n++) {
        if (kids[n].nodeType === 3 && kids[n].nodeValue.trim()) { lead = kids[n]; break; }
      }
      if (lead) {
        if (labels[L].dataset.ntfDelivWord == null) labels[L].dataset.ntfDelivWord = lead.nodeValue;
        lead.nodeValue = haveDate() ? "" : labels[L].dataset.ntfDelivWord;
      }
      var slot2 = labels[L].querySelector(".ntf-ship-rowdate");
      if (!slot2) {
        slot2 = document.createElement("span");
        slot2.className = "ntf-ship-rowdate";
        labels[L].appendChild(slot2);
      }
      /* No leading space when the word is gone, or the date starts indented from the icon. */
      var w2 = (haveDate() ? "" : " ") + LEAD_DATE + "*";   // the footnote in the sheet explains it
      if (slot2.textContent !== w2) slot2.textContent = w2;
      labels[L].dataset.ntfDelivDate = LEAD_DATE;
    }
  }
  /* whenText() returns "" when the zone has no transit times, so a date is any non-empty one. This
     compared against the English "At checkout" until 25 Sept (rule 1). */
  function haveDate(){ return !!LEAD_DATE; }
  /* True once the rates call has finished, whatever it returned. It is the difference between
     "no date yet" and "no date at all", and only the second one is a reason to show the theme's
     own copy. */
  var RATES_SETTLED = false;
  /* Published, because syncDelivery() in ntf-cart.js writes the same row and has to know whether
     to keep out of the way. settled = the rates call has finished, whatever it returned. */
  window.NTF_SHIP_STATE = window.NTF_SHIP_STATE || { settled:false, hasDate:false };
  /* The picked country's free-shipping threshold, for ntf-cart.js - the LOWEST of the zone's
     per-service thresholds, in the zone's own currency. Computed here so it can be published at
     init as well as on every state change: until it is, shipThresholdCents() falls back to the
     browsing market, and a customer with a stored pick saw the rung flip two seconds in. */
  function zoneState(){
    var z = zoneOf(ISO);
    if (!z || !z.f) return null;
    var best = null;
    for (var k in z.f){ if (!Object.prototype.hasOwnProperty.call(z.f, k)) continue;
      var v = z.f[k]; if (v != null && isFinite(v) && (best === null || v < best)) best = v; }
    return best === null ? null : { free_from: best, c: z.c || "EUR", iso: ISO };
  }
  window.NTF_SHIP_STATE.zone = zoneState();
  /* The first transit workday of the country's slowest service, for the pre-order delivery range on the product page
     (snippets/ntf-preorder.liquid, Kai 28 Oct 2026). Slowest, so the earliest date shown is one every service meets. */
  function transitState(){ var r = compiledRates(ISO); return r.length && r[0].delivery_days.length ? r[0].delivery_days[0] : null; }
  window.NTF_SHIP_STATE.transit = transitState();
  /* The same-day cut-off of the lead service, as a bare clock time ("13:00"): the {cutoff} in the
     info pages' text (snippets/ntf-page-body.liquid). Not cutTime(), which moves on to "23:59" once
     today's hand-over has passed - a page stating the rule needs the rule, not the next deadline.
     Express until the rates say which service leads. */
  function cutoffState(){ return hhmm(cutoffFor(LEAD_RATE ? LEAD_RATE.name : "express") * 60); }
  window.NTF_SHIP_STATE.cutoff = cutoffState();
  function publishState(){
    window.NTF_SHIP_STATE.settled = RATES_SETTLED;
    window.NTF_SHIP_STATE.hasDate = haveDate();
    /* The lead service, for the product page's line: the same date the cart row prints, and the
       same deadline the sheet prints beside that service. cut is the bare time from cutTime(); it
       was the sheet's sentence with the English words "Order before " cut off the front, which
       matches nothing once that sentence is Dutch - the product line would have read "Bestel voor
       Bestel voor 13:00". */
    window.NTF_SHIP_STATE.lead = (haveDate() && LEAD_RATE)
      ? { date: LEAD_DATE, cut: cutTime(LEAD_RATE.name), name: shortName(LEAD_RATE.name) }
      : null;
    window.NTF_SHIP_STATE.zone = zoneState();
    window.NTF_SHIP_STATE.cutoff = cutoffState();
    window.NTF_SHIP_STATE.transit = transitState();
    try { window.dispatchEvent(new CustomEvent("ntf:ship-state")); } catch(e){}
  }
  function stripBlockCopy(){
    /* Hidden from the first pass, not from the first date. Waiting for a date of our own meant the
       theme's heading — "Delivery September 04", set large — was on screen for as long as the
       rates took, then swapped for ours: a flash on every open. It is only restored once the rates
       have come back WITHOUT a date, which is the case this fallback was written for.
       (Hiding it unconditionally, with no restore at all, is what left the row as a bare truck
       icon in the first place — that is still not what happens here.) */
    if (RATES_SETTLED && !haveDate()) {
      var shown = document.querySelectorAll(".ntf-ship-hide");
      for (var v = 0; v < shown.length; v++) shown[v].classList.remove("ntf-ship-hide");
      return;
    }
    /* One marker, rendered by snippets/cart-drawer.liquid and sections/main-cart-items.liquid on
       the paragraph this feature supersedes.

       What stood here climbed three ancestors from each .ntf-ship box, walked every p/h/span/div
       beneath it, and hid whatever began with "Delivery " + a digit or with "estimated with" —
       then needed four separate guards to stop it hiding the replacement text it had just written.
       Every one of those tests was English. Measured against the preview on 2026-09-14: on /cart
       exactly ONE element was ever hidden, the .ntf-fdet-body paragraph; the "Delivery <date>"
       branch matched nothing at all. On /nl/wagen nothing matched, which is half of why the Dutch
       row had no date. The marker does the same job in one line, in every language, and cannot
       catch our own output because our own output does not carry it. */
    /* Only where it is missing. classList.add() writes the class attribute even when the class is
       already there, and a class write is exactly what the shared NTF_ON_MUTATE observer listens
       for - so this function, registered with that observer, re-triggered itself: every frame, on
       every page, for as long as the page was open (measured 25 Sept on a 4x-throttled phone: 120
       class writes a second while idle, and every guard in the registry run on every frame - the
       "short delay after each click" Kai felt in the drawer). */
    var copy = document.querySelectorAll("[data-ntf-blockcopy]:not(.ntf-ship-hide)");
    for (var i = 0; i < copy.length; i++) copy[i].classList.add("ntf-ship-hide");
  }
  /* Quote the fastest date once at start-up, independent of any sheet.

     paintRowDate only had a date after a sheet had rendered, and in the drawer the sheet does not
     render until the popup is opened — so the row sat there as a bare truck icon with the block's
     own date hidden and nothing in its place. One request at load fills it in; the sheet reuses the
     same response rather than asking again. */
  /* The row quotes the country the customer is shipping TO - the one picked in the sheet's list,
     falling back to the detected market when nothing has been picked. Kai, 24 Sept: picking a
     different country has to move the date on the cart row and on the product page too.

     This was pinned to DETECTED because of the Albania bug: a stored country whose zone has no
     transit times kept quoting "At checkout" on the row while the sheet three lines below said
     Mon 31 Aug. That was an inconsistency between two surfaces reading two different countries -
     which is exactly what following ISO everywhere removes. Both read the same country now, so
     when the answer is "At checkout" they say so together, which is the honest result. */
  var ROW_ISO = ISO;
  /* Re-quote the row for a newly picked country. LEAD_DATE has to be cleared or primeRowDate
     returns immediately, and RATES_SETTLED has to go back to false or stripBlockCopy restores the
     theme's own "Delivery <date>" copy in the gap before the new rates land. */
  function reprimeRow(){
    ROW_ISO = ISO; LEAD_DATE = ""; LEAD_RATE = null; SHIP_COST = null; RATES_SETTLED = false;
    publishState(); paintRowDate(); primeRowDate();
  }
  function primeRowDate(){
    if (LEAD_DATE) return;
    /* The country this call is FOR. A pick while it is in flight starts a new call; this one must
       then settle nothing, or whichever answer lands last - possibly the old country's - wins the
       row (review, 25 Sept: reachable since the row began following the pick). */
    var iso = ROW_ISO;
    fetch("/cart.js?_=" + Date.now(),{headers:{Accept:"application/json"},cache:"no-store"})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        /* A sentinel, not null: null means "no rates came back" and falls through to the
           compiled table below, which would invent a delivery date for a made-to-order item. */
        if (hasCustomLine(cart)) return "custom";
        setTotalBase(cart.total_price);
        return ratesFor(iso, cart.total_price);
      })
      .then(function(rates){
      if (iso !== ROW_ISO) return;
      /* Made to order: there is no honest lead time, so settle with no date rather than let
         the compiled table below supply one. paintRowDate strips any stale date, stripBlockCopy
         restores the theme's own made-to-order copy, and publishState tells ntf-cart.js there
         is nothing to sync. The row then promises nothing, which is the point. */
      if (rates === "custom") {
        RATES_SETTLED = true; LEAD_DATE = ""; LEAD_RATE = null;
        publishState(); paintRowDate(); stripBlockCopy();
        return;
      }
      if (!rates || !rates.length) rates = compiledRates(iso);
      if (!rates || !rates.length) { RATES_SETTLED = true; publishState(); stripBlockCopy(); return; }
      var f = rates.slice().sort(function(a, b){
        var A2 = a.delivery_days || [99,99], B2 = b.delivery_days || [99,99];
        var au = A2[A2.length-1], bu = B2[B2.length-1];
        return au !== bu ? au - bu : A2[0] - B2[0];
      })[0];
      if (!f) return;
      // Cheapest, not fastest: the totals line is what the cart will be charged if nothing else
      // is chosen, and Shopify sorts this list by price for exactly that reason.
      SHIP_COST = f.compiled ? null : Math.min.apply(null, rates.map(function(x){ return parseFloat(x.price); }));
      LEAD_DATE = whenText(f.delivery_days, f.name);
      LEAD_RATE = f;
      RATES_SETTLED = true;
      publishState();
      paintRowDate();
    }).catch(function(){ if (iso !== ROW_ISO) return; RATES_SETTLED = true; publishState(); stripBlockCopy(); });
  }
  if (window.NTF_ON_MUTATE) { window.NTF_ON_MUTATE(stripBlockCopy); window.NTF_ON_MUTATE(paintRowDate); }
  else { setInterval(stripBlockCopy, 700); setInterval(paintRowDate, 700); }
  primeRowDate();
})();
